import React from 'react';
import { SurveyCard } from './SurveyCard';

export type CompletedSurveyProps = {
  name: string;
  onViewResults: () => void;
};

export const CompletedSurvey = ({ name, onViewResults }: CompletedSurveyProps): JSX.Element => (
  <SurveyCard
    title={name}
    status="completed"
    onActionPress={onViewResults}
    actionLabel="View Results"
    ariaLabel="View survey results"
    actionTestId="pressable-survey-view-results"
    actionVariant="secondary"
  />
);
